"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderSummaryDeadlineLabel = exports.TradeIntervalLabel = exports.MaxDurationLabel = exports.LimitPriceLabel = exports.CurrentMarketPriceLabel = exports.TotalTradesLabel = exports.ChunksAmountLabel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var __1 = require("..");
var context_1 = require("../context/context");
var base_1 = require("./base");
var utils_1 = require("../utils");
var lib_1 = require("../hooks/lib");
function ChunksAmountLabel() {
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.tradeSize }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: translations.tradeSizeTooltip })] }));
}
exports.ChunksAmountLabel = ChunksAmountLabel;
var TotalTradesLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.totalTrades }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: translations.totalTradesTooltip })] }));
};
exports.TotalTradesLabel = TotalTradesLabel;
var CurrentMarketPriceLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(base_1.Label, { children: (0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.currentMarketPrice }) }));
};
exports.CurrentMarketPriceLabel = CurrentMarketPriceLabel;
var LimitPriceLabel = function () {
    var _a = (0, context_1.useTwapContext)(), t = _a.translations, isLimitPanel = _a.isLimitPanel;
    var isMarketOrder = (0, lib_1.useIsMarketOrder)();
    return ((0, jsx_runtime_1.jsx)(__1.Styles.StyledRowFlex, __assign({ justifyContent: "flex-start", style: { width: "auto", position: "relative" }, gap: 3 }, { children: (0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: !isLimitPanel ? t.price : t.limitPrice }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: isMarketOrder ? t.marketPriceTooltip : isLimitPanel ? t.limitPriceTooltipLimitPanel : t.limitPriceTooltip })] }) })));
};
exports.LimitPriceLabel = LimitPriceLabel;
var MaxDurationLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.expiry }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: translations.maxDurationTooltip })] }));
};
exports.MaxDurationLabel = MaxDurationLabel;
var TradeIntervalLabel = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    var getMinimumDelayMinutes = (0, lib_1.useMinimumDelayMinutes)();
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.tradeInterval }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: (0, utils_1.handleFillDelayText)(translations.tradeIntervalTootlip, getMinimumDelayMinutes) })] }));
};
exports.TradeIntervalLabel = TradeIntervalLabel;
var OrderSummaryDeadlineLabel = function (_a) {
    var _b;
    var subtitle = _a.subtitle, _translations = _a.translations;
    var translations = ((_b = (0, context_1.useTwapContext)()) === null || _b === void 0 ? void 0 : _b.translations) || _translations;
    return ((0, jsx_runtime_1.jsxs)(base_1.Label, { children: [(0, jsx_runtime_1.jsx)(base_1.Label.Text, { text: translations.expiration }), (0, jsx_runtime_1.jsx)(base_1.Label.Info, { text: translations.confirmationDeadlineTooltip })] }));
};
exports.OrderSummaryDeadlineLabel = OrderSummaryDeadlineLabel;
